export default "__VITE_ASSET__31110bf2__"